export enum SttMarkerType {
  AutoGeneratedHearing = 'auto-generated-hearing',
  Hearing = 'hearing',
  Sealing = 'sealing',
  Session = 'session',
}
